function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.6591 9.2315C14.9658 8.92283 15.4632 8.92283 15.7698 9.2315C16.0565 9.51883 16.0752 9.97349 15.8272 10.2835L15.7698 10.3482L11.3711 14.7688C11.1045 15.0368 10.6891 15.0741 10.3818 14.8688L10.3125 14.8174L8.28245 13.1168C7.94912 12.8375 7.90445 12.3395 8.18245 12.0048C8.44112 11.6921 8.88979 11.6315 9.21979 11.8521L9.28846 11.9035L10.7671 13.1421L14.6591 9.2315Z",
  fill: "#ffffff"
});

var SvgSelector = function SvgSelector(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSelector, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/selector.5b1482c2.svg";
export { ForwardRef as ReactComponent };